import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class NewUpdateScreenService {
  // Mirror of legacy `newUpdateScreenFactory.url` (action_code w URL query string).
  private url = {
    get_client_table_details: '/loadJsonObject?action_code=swr9rk',
    get_core_table_details: '/loadJsonObject?action_code=nbqlj6',
    get_client_impacted_details: '/loadJsonObject?action_code=owv0rd',
    get_core_impacted_details: '/loadJsonObject?action_code=unyqr5',
    update_client_data_table: '/saveJsonObject?action_code=w79uoi',
    update_core_data_table: '/saveJsonObject?action_code=zfid1f'
  };

  constructor(private http: HttpClient) { }

  getTableDetails(baseUrl: string, environmentLabel: string, tableName: string): Observable<any> {
    const path = environmentLabel === 'Client'
      ? this.url.get_client_table_details
      : this.url.get_core_table_details;

    let params = new HttpParams();
    if (tableName) {
      params = params.set('table_name', tableName);
    }

    return this.http.get<any>(`${baseUrl}${path}`, { params, withCredentials: true });
  }

  getImpactedData(baseUrl: string, environmentLabel: string, requestParams: any): Observable<any> {
    const path = environmentLabel === 'Client'
      ? this.url.get_client_impacted_details
      : this.url.get_core_impacted_details;

    return this.postUrlEncoded(`${baseUrl}${path}`, requestParams || {});
  }

  performAction(
    baseUrl: string,
    environmentLabel: string,
    payload: any,
    globalService: any
  ): Observable<any> {
    const path = environmentLabel === 'Client'
      ? this.url.update_client_data_table
      : this.url.update_core_data_table;
    const globalParams = _.merge({}, globalService?.globalParams || globalService || {});
    // Legacy contract: action_code is passed in query string, not request body.
    // Strip any accidental action_code leaked from workspace/global params.
    delete (globalParams as any).action_code;

    const params = _.merge({}, globalParams, payload || {});

    return this.postUrlEncoded(`${baseUrl}${path}`, params);
  }

  private postUrlEncoded(url: string, params: any): Observable<any> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params || {}).forEach((key: string) => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, this.serializeParamValue(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  private serializeParamValue(value: any): string {
    if (typeof value === 'string') {
      return value;
    }
    if (value === null || value === undefined) {
      return '';
    }
    return typeof value === 'object' ? JSON.stringify(value) : String(value);
  }
}
